module.exports = __webpack_public_path__ + "img/founder-toucan.64e58b8c.png";